import { Int } from '@adornis/baseql/baseqlTypes.js';
import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { getCollectionHandle } from '@adornis/baseql/server/collections.js';
import { publishFilter } from '@adornis/baseql/server/context.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { catchError, from, of, switchMap } from 'rxjs';
import { WorkshopAttendance } from '../entities/WorkshopAttendance.js';
import { WorkshopFilter } from '../entities/WorkshopFilter.js';
import { WorkshopTrainingAttendance } from '../entities/WorkshopTrainingAttendance.js';

export const subscribeWorkshopTrainingAttendanceSimple = registerSubscription({
  type: () => [WorkshopTrainingAttendance],
  operationName: 'subscribeWorkshopTrainingAttendanceSimple',
  resolve: (skip: number, limit: number, filter: WorkshopFilter) => {
    return (gqlFields: BaseQLSelectionSet<WorkshopAttendance>) => {
      const selector = {
        _class: WorkshopTrainingAttendance._class,
        ...filter.getMongoFilter(),
      };
      const handle = getCollectionHandle<WorkshopTrainingAttendance>(WorkshopAttendance._collectionName);
      return from(publishFilter(WorkshopAttendance._class)).pipe(
        switchMap(publishFilter => {
          return handle.watchQuery(publishFilter ? { $and: [publishFilter, selector] } : selector, {
            skip,
            limit,
          });
        }),
        catchError(e => {
          return of([] as WorkshopTrainingAttendance[]);
        }),
      );
    };
  },
  params: [
    {
      name: 'skip',
      type: () => Int,
    },
    {
      name: 'limit',
      type: () => Int,
    },
    {
      name: 'filter',
      type: () => WorkshopFilter,
    },
  ],
});
